// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-container{flex:1;overflow:auto;height:100%}`, "",{"version":3,"sources":["webpack://./src/taskpane/components/Email.scss"],"names":[],"mappings":"AAAA,gBACI,MAAA,CACA,aAAA,CACA,WAAA","sourcesContent":[".main-container {\n    flex: 1;\n    overflow: auto;\n    height: 100%\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
